<template>
  <div class="sem-justificativa fonte-secundaria">
    <div class="icone-arquivo mb-3" style="position: relative">
      <IconeArquivo />
      <span class="texto-arquivo noselect"> 406 </span>
    </div>
    <div class="subtitulo">Nenhuma justificativa enviada</div>
    <div
      class="ml-auto mr-auto cor-principal noselect text-underline mt-2"
      @click="$emit('redirecionar')"
    >
      Entre em contato com a singular
    </div>
  </div>
</template>

<script>
import IconeArquivo from "../Icones/IconeArquivo";

export default {
  components: {
    IconeArquivo
  }
};
</script>

<style lang="scss" scoped>
.sem-justificativa {
  height: 230px;
  background: #f1f2f1;
  padding: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .icone-arquivo {
    margin: 0 auto;

    .texto-arquivo {
      font-size: 10px;
      position: absolute;
      left: 27%;
      top: 45%;
    }
  }
}
</style>
